export default __webpack_public_path__ + "static/media/logo.a7de6183.png";